
/**
 * @fileoverview LoanStatus Component - Displays loan status information
 * @version 1.0.0
 * 
 * @component
 * @description A React component that shows the status of a loan and provides navigation back to dashboard
 * 
 * @example
 * // Basic usage
 * <LoanStatus status="Approved" />
 * 
 * // Different status examples
 * <LoanStatus status="Pending" />
 * <LoanStatus status="Rejected" />
 * 
 * @param {Object} props - Component props
 * @param {string} props.status - The loan status to display
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoanStatus = ({ status }) => {
    // Hook for programmatic navigation
    const navigate = useNavigate();

    return (
        <div className="loan-status-container">
            {/* Display the loan status in heading */}
            <h1>{status} Status</h1>

            {/* Placeholder text showing current status */}
            <p>This is a placeholder page for the {status} loan status.</p>

            {/* Navigation button to return to dashboard */}
            <button onClick={() => navigate('/dashboard')}>Back to Dashboard</button>
        </div>
    );
};

export default LoanStatus;
